<template>
	<div class="container">
		<h3>{{ title }}</h3>
		<img class="logo" src="@/assets/mint_logo.png" />
		<div class="inner">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'funFact',
	props: ['title']
}
</script>

<style lang="scss" scoped>
.container {
	margin-top: 75px;
	margin-bottom: 10px;
	color: #fff;
	position: relative;
	h3 {
		margin-bottom: 0px;
		color: #fff !important;
		margin-left: 42px;
	}
	.logo {
		position: absolute;
		top: 20px;
		height: 38px;
		width: 38px;
	}
	.inner {
		width: 100%;
		max-width: 400px;
		border: 1px solid $bluegrad1;
		border-radius: 5px;
		align-items: center;
		display: flex;
		padding: 10px;
		font-size: 14px;
		line-height: 20px;
	}
}
</style>
